import React, { useEffect, useState } from "react";
import { CModal, CModalBody } from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import { hideAddBankModal, showAddBankModal } from "../redux/bankModalDispatcher";
import { addBankRequest } from "../redux/bankDispatcher";

const AddBank = ({ buttonLabel = "Add Bank", editMode = false, bankData = {} }) => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [bankName, setBankName] = useState("");

  useEffect(() => {
    if (editMode && bankData) {
      setBankName(bankData.name || "");
    }
  }, [editMode, bankData]);

  const resetForm = () => {
    setBankName("");
  };

  const handleAddBank = () => {
    if (bankName.trim() === "") {
      alert("Bank name is required");
      return;
    }

    const data = { name: bankName };
    if (editMode) {
      data.id = bankData.id;
    }

    dispatch(addBankRequest(data));
    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddBankModal());
  };

  return (
    <div>
      <button
        onClick={() => {
          if (!editMode) resetForm();
          setIsModalVisible(true);
          dispatch(showAddBankModal());
        }}
        style={{
          backgroundColor: editMode ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode ? "10px" : "14px",
          minWidth: "60px",
          height: editMode ? "24px" : "30px",
          padding: editMode ? "2px 5px" : "4px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {buttonLabel}
      </button>

      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"
      >
        <CModalBody className="main-container createAdmin">
          <div className="cross-btn-div d-flex">
            <img
              onClick={() => setIsModalVisible(false)}
              src={crossButton}
              alt="close"
              className="cross-button"
            />
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="login-form">
            <div className="mb-4">
              <h4 className="h4 fw-bold" style={{ color: "#007bff", textAlign: "center" }}>
                <b>{editMode ? "Edit Bank" : "Add New Bank"}</b>
              </h4>
            </div>

            <div className="mb-3 input-login-box">
              <input
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
                name="bankName"
                type="text"
                className="form-control login-input"
                placeholder="Enter bank name"
              />
            </div>

            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="button"
              onClick={handleAddBank}
            >
              {editMode ? "Update" : "Submit"}
            </button>
          </form>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddBank;
